import Alert from 'components/Alert'
import { Modal } from 'components/desktop/common/Modal'
import { Banner, Contract, Logout } from 'components/shard'
import { Color, Gap, Responsive, Size } from 'const'
import { useServiceHook } from 'hooks'
import _ from 'lodash'
import React, { useEffect } from 'react'
import styled from 'styled-components'

function Service() {
  const {
    services,
    servicesErrors,
    setServicesErrors,
    isServicesRequestingAPI,
    getServices,
    getCreditCardForList,
    modalDisplay,
    close,
    link,
    getContractItems,
    PRODUCT_CLASSIFICATION,
  } = useServiceHook()

  useEffect(() => {
    getServices()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (services.length > 0) {
      getCreditCardForList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [services.length])

  const serviceArgs = {
    getContractItems,
    PRODUCT_CLASSIFICATION,
  }

  return (
    <>
      {isServicesRequestingAPI ? (
        <ServiceBlock>
          <Msg>ご利用・ご契約状況の確認中。</Msg>
        </ServiceBlock>
      ) : (
        <ServiceBlock>
          {servicesErrors.length > 0 && (
            <Alert
              type="error"
              message="エラー"
              description={servicesErrors.join('\n')}
              onClose={() => setServicesErrors([])}
            />
          )}
          {services.length > 0 ? (
            <>
              <Modal
                title="クレジットカードの登録"
                text="クレジットカードを登録ください。"
                caution="プリペイドやデビットの場合、申込直後に請求される場合があります。"
                display={modalDisplay}
                overlayOnClick={close}
                buttonOnClick={link}
              />
              <BoxLabel>契約履歴一覧</BoxLabel>
              {services.length > 0 && (
                <Announcement>
                  {
                    'クレジットカードの変更は契約中のプランをクリック↓\n※複数ご契約中の場合、一括変更されませんのでご注意下さい'
                  }
                </Announcement>
              )}
              <BoxList services={services} {...serviceArgs} />
            </>
          ) : (
            <>
              <Msg>現在、NINALご利用はありません。</Msg>
            </>
          )}
        </ServiceBlock>
      )}
      <Banner />
      <Logout />
    </>
  )
}

function BoxList({ services, ...rest }) {
  return (
    <BoxListWrapper>
      {_.map(services, (service) => (
        <Contract key={service.dev_contractid} contract={_.merge(service, rest)} />
      ))}
    </BoxListWrapper>
  )
}

const ServiceBlock = styled.div`
  padding: 16px 0 40px 0;
  border-radius: 10px;
  border: 1px solid ${Color.LINE.NORMAL};
  background-color: ${Color.BACKGROUND.BLOCK};
  margin: 20px 0 60px;
`

const BoxListWrapper = styled.div`
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${Gap.LG};

  @media screen and (max-width: ${Responsive.LG.DOWN}px) {
    grid-template-columns: 1fr;
  }
`

const BoxLabel = styled.div`
  font-size: ${Size.FONT.LG};
  padding: 16px 24px;
  font-weight: 700;
`

const Announcement = styled.div`
  color: ${Color.FONT.ANNOTATION_RED};
  font-size: ${Size.FONT.HEADLINE.MEDIUM};
  padding: 0 24px 28px;
  white-space: pre-line;
  font-weight: 700;
`
const Msg = styled.div`
  font-size: ${Size.FONT.MSG};
  padding: 24px 0 0;
  text-align: center;
`
export default Service
